<div>
<label label class="label aligned" isEllipsisActive>
    <ng-content select="[label]"></ng-content>
</label>
<label class="toggle">
    <input type="checkbox" [(ngModel)]="value" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()" #switchEl  [disabled]="!isEdit"  class="toggle__input"/>
    <span class="toggle-track" [ngClass]="isEdit ? '' : 'removeHand'" (mouseenter)="checkEdit()">
        <span class="toggle-indicator" [ngClass]="isEdit ? '' : 'readModeColor'">
            <!-- 	check mark if true -->
            <span class="checkMark">
                <svg viewBox="0 0 24 23" id="ghq-svg-check" role="presentation" aria-hidden="true">
                    <path
                        d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                    </path>
                </svg>
            </span>
             <!-- 	check mark if true end -->
        </span>
    </span>
</label>
</div>